var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height py-3 py-md-10"},[_c('v-container',{staticClass:"flex-center fill-height"},[_c('div',{staticClass:"notfound-text"},[_vm._v("Page not found.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }